'use strict';

var windowscroll = require('improove/util/windowscroll');
var previousScroll = 0;

module.exports = function () {
    // Grab the html of the <isinclude template="components/header/menuIcons"/>
    // include and inject it into the .header-main (the scroll header)
    // This is to get around the below remote include that have been loading twice each page load:
    // <isinclude url="${URLUtils.url('Account-Header')}" />
    // <isinclude url="${URLUtils.url('Cart-MiniCart')}" />
    var iconsHtml = $('.header-top .header-menu-icons').html();
    $('.header-main .header-menu-icons').html(iconsHtml);
    const headerNotificationPopup = $('.header-notification, .notification-popup-arrow-container');

    function headerScrollCallback() {
        var currentScroll = $(window).scrollTop();
        if (currentScroll > previousScroll && $(window).scrollTop() > 200) {
            $('.header').addClass('scroll-down');

            if ($('.account-navigation-menu-wrapper').length > 0) {
                $('.account-navigation-menu-wrapper').addClass('scroll-down');
                $('.account-navigation').addClass('scroll-down');
            }
        } else {
            $('.header').removeClass('scroll-down');

            if ($('.account-navigation-menu-wrapper').length > 0) {
                $('.account-navigation-menu-wrapper').removeClass('scroll-down');
                $('.account-navigation').removeClass('scroll-down');
            }
        }


        if (currentScroll > 200) {
            $('.header').addClass('sticky');
            if (headerNotificationPopup.length > 0) {
                headerNotificationPopup.fadeOut();
            }
        } else {
            $('.header').removeClass('sticky');
            if (headerNotificationPopup.length > 0) {
                headerNotificationPopup.fadeIn();
            }
        }

        previousScroll = currentScroll;
    }

    $('.header-notifcation-close').on('click', function () {
        headerNotificationPopup.fadeOut(400, function () {
            headerNotificationPopup.remove();
            $('.header-main .header-login-link').trigger('focus');
        });
    });

    windowscroll.addCallback(headerScrollCallback);
};
